import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { cdnUrl } from '../../../../../utils/url/url';
import LazyLoadedImage from '../../LazyLoadedImage/LazyLoadedImage';

const SwatchDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.mobile ? 'column' : 'row')};
  border: 1px solid ${(props) => props.theme.colors.shades[5]};
  margin: 5px;
  padding: 5px 5px;
  border-radius: 5px;
  text-decoration: none;
  cursor: pointer;
  ${(props) => props.highlighted && css`
    border: 2px solid ${props.theme.colors.primary.default};
  `};
`;

const SwatchImg = styled(LazyLoadedImage)`
  img {
    height: 45px;

    ${(props) => !props.mobile && css`
      padding-right: 5px;
    `};
  }
`;

const SwatchLabel = styled.div`
  color: ${(props) => props.theme.colors.link.default};
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) => props.mobile && css`
    margin-top: 5px;
  `};
`;

export default function SegmentSwatch({
  label, imgSrc, highlighted, mobile, onClick
}) {

  return (
    <SwatchDiv highlighted={highlighted} mobile={mobile} onClick={onClick}>
      {/* TODO: remove condition for imgSrc as soon as segment images are delivered in fo-site UCMS call response */}
      <SwatchImg src={imgSrc ? imgSrc : cdnUrl('/img/currys_logo_small.png')} alt={imgSrc} mobile={mobile} />
      <SwatchLabel mobile={mobile}>{label}</SwatchLabel>
    </SwatchDiv>
  );
}

SegmentSwatch.propTypes = {
  label: PropTypes.string,
  imgSrc: PropTypes.string,
  mobile: PropTypes.bool,
  highlighted: PropTypes.bool,
  onClick: PropTypes.func
};

SegmentSwatch.defaultProps = {
  label: '',
  imgSrc: '',
  mobile: false,
  highlighted: false,
  onClick: () => {}
};
